/***
 * Configuration for Products Routes
 *
 * Product Routes
 ***/

/* ----- Views ----- */

// Product
import Products from "@/pages/Products/Products";
import ProductAdd from "@/pages/Products/ProductAdd";
import ProductEdit from "@/pages/Products/ProductEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

const parentsList = {
    productsIndex: { label: 'Liste des produits', name: 'Products' },
}

const productRoutes = [
    {
        path: 'products',
        name: 'Products',
        component: Products,
        meta: {
            route: {
                label: 'Liste des produits'
            }
        },
    },
    {
        path: 'products/create',
        name: 'Add Product',
        component: ProductAdd,
        meta: {
            route: {
                label: 'Ajout d\'un produit'
            },
            parents: generateParentsList(parentsList, ['productsIndex']),
        },
    },
    {
        path: 'products/:id/edit',
        name: 'Edit Product',
        component: ProductEdit,
        meta: {
            route: {
                label: 'Modification d\'un produit',
                params: { name: 'id', model: 'Product', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['productsIndex']),
        },
    },
]

const routes = [...productRoutes]
export default routes